import AnnouncementServices from '@/services-ts/Message/AnnouncementServices'
import MessageServices from '@/services-ts/Message/MessageServices'
import MessageTemplateServices from '@/services-ts/Message/MessageTemplateServices'
import NotificationServices from '@/services-ts/Message/NotificationServices'

const MessageAPI = (apiMessage: string) => {
  return {
    AnnouncementServices: new AnnouncementServices(apiMessage),
    NotificationServices: new NotificationServices(apiMessage),
    MessageTemplateServices: new MessageTemplateServices(apiMessage),
    MessageServices: new MessageServices(apiMessage),
  }
}

export default MessageAPI
